import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faReply, faPrint, faCalculator } from '@fortawesome/pro-regular-svg-icons'
// import { faSave } from '@fortawesome/pro-solid-svg-icons'
import { FusionColor } from '../../../theme/FusionStyle'
import { V2L1ReasonableButton } from '../Button/V2L1ReasonableButton'
import { V2L1AppHeaderSpacer, V2L1AppHeaderTitle } from './V2L1AppHeaderComponents'

const DateOfService = styled.div({
	'> svg': {
		position: 'relative',
		top: '-1px',
		marginRight: '0.3em',
	},
})

export enum V2L3FormAppHeaderAction {
	BackToDashboard = 'backToDashboard',
	SaveDraft = 'saveDraft',
	Loading = 'loading',
	None = 'none',
}

interface V2L3FormAppHeaderContentProps {
	memberName: string
	memberInfo: string
	dateOfServiceInfo?: string
	canPrint?: boolean
	onPrintClick?: () => void
	action: V2L3FormAppHeaderAction
	onActionClick?: () => void
}

export const V2L3FormAppHeaderContent = ({
	memberName,
	memberInfo,
	dateOfServiceInfo,
	canPrint,
	onPrintClick,
	action,
	onActionClick,
}: V2L3FormAppHeaderContentProps) => {
	let actionNode: ReactNode
	switch(action) {
		case V2L3FormAppHeaderAction.BackToDashboard:
		case V2L3FormAppHeaderAction.SaveDraft:
		case V2L3FormAppHeaderAction.Loading:
			actionNode = (
				<V2L1ReasonableButton
					color={FusionColor.White}
					loading={action === V2L3FormAppHeaderAction.Loading}
					icon={faReply}
					label="Back to Dashboard"
					onClick={onActionClick}
				/>
			)
			// previous Save button appearance:
			// actionNode = (
			// 	<V2L1ReasonableButton
			// 		color={FusionColor.OrangeMain}
			// 		loading={action === V2L3FormAppHeaderAction.Loading}
			// 		icon={faSave}
			// 		label="Back to Dashboard"
			// 		onClick={onActionClick}
			// 	/>
			// )
			break
		case V2L3FormAppHeaderAction.None:
		default:
			actionNode = null
	}
	return (
		<>
			<V2L1AppHeaderTitle>{memberName}</V2L1AppHeaderTitle>
			<div>{memberInfo}</div>
			<V2L1AppHeaderSpacer />
			{dateOfServiceInfo ? (
				<DateOfService>
					<FontAwesomeIcon icon={faCalendarDays} />
					{dateOfServiceInfo}
				</DateOfService>
			) : null}
			{canPrint ? (
				<V2L1ReasonableButton
					icon={faPrint}
					color={FusionColor.White}
					onClick={onPrintClick}
				/>
			) : null}
			{actionNode}
		</>
	)
}
